import { render, staticRenderFns } from "./goal-setup.vue?vue&type=template&id=21d84aed&"
import script from "./goal-setup.vue?vue&type=script&lang=ts&"
export * from "./goal-setup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports